import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import FeaturedProducts from './components/FeaturedProducts';
import CTASection from './components/CTASection';
import { useProducts } from '@/hooks/useProducts';
import { Product } from '@/mocks/products';

const HomePage = () => {
  const { getSliderProducts, products } = useProducts();
  const [sliderProducts, setSliderProducts] = useState<Product[]>([]);

  useEffect(() => {
    setSliderProducts(getSliderProducts());
  }, [products]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSlider products={sliderProducts} />
      <ServicesSection />
      <WhyUsSection />
      <FeaturedProducts products={products} />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
